export default __webpack_public_path__ + "static/media/tv-guide.a7c5d784.jpg";